module.exports = __webpack_public_path__ + "static/media/mssg_schedule_pt_PT.4edc7fd1.png";